import { render } from "./InvoiceStatusForm.vue?vue&type=template&id=54efc24c&scoped=true"
import script from "./InvoiceStatusForm.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusForm.vue?vue&type=script&lang=js"

import "./InvoiceStatusForm.vue?vue&type=style&index=0&id=54efc24c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54efc24c"]])

export default __exports__